import DocViewerServiceBase from '../../../common/api/docViewerServiceBase';
import { ensureTrailingSlash } from '../../../common/utils/urlHelper';
import { IEnrichmentStatus } from './models/enrichmentStatus';
import { IViewInlLibraryStatusResponse } from './models/viewInlLibraryStatusResponse';
import { AxiosRequestConfig, Method } from 'axios';

export default class OrderViewerApiService extends DocViewerServiceBase {
	constructor(basePath: string) {
		super(basePath);
	}

	public async getDocEnrichmentStatusAsync(orderId: number, userId: number): Promise<IEnrichmentStatus> {
		const baseConfig = super.createBaseRequest();

		const request: AxiosRequestConfig = {
			...baseConfig,
			baseURL: ensureTrailingSlash(this.basePath),
			url: '/services/Enrichment/GetDocEnrichmentStatus',
			method: 'get' as Method,
			params: { orderId, userId }
		};
		const response = await super.sendAsync<IEnrichmentStatus>(request);
		this.throwIfFailedResponse(response, localize('Error while getting document enrichment status.'));
		return response.data;
	}

	public async changeAutoLinksEnabled(orderId: number, isAutoLinksEnabled: boolean): Promise<boolean> {
		const baseConfig = super.createBaseRequest();
		const request: AxiosRequestConfig = {
			...baseConfig,
			baseURL: ensureTrailingSlash(this.basePath),
			url: '/services/orderViewer/ChangeAutoLinksEnabled',
			method: 'post' as Method,
			params: { orderId, isAutoLinksEnabled }
		};
		const response = await super.sendAsync<boolean>(request);
		this.throwIfFailedResponse(response, localize('Error while changing AutoLinks setting request.'));
		return response.data;
	}

	public async checkViewInLibraryStatus(contentId: number): Promise<IViewInlLibraryStatusResponse> {
		const request = {
			url: '/CheckViewInLibraryStatus',
			method: 'get' as Method,
			params: { contentId },
			...this.createBaseRequest()
		};
		const response = await super.sendAsync<IViewInlLibraryStatusResponse>(request);
		this.throwIfFailedResponse(response, localize('Error while checking document in library.'));
		return response.data;
	}
}
